import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";

import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import useRadioStyles from "../../styles/useRadioStyles";

const CustomRadio = ({ label, color, ...props }) => {
  const classes = useRadioStyles();
  const [field] = useField({ ...props, type: "radio" });
  let radioClassName;
  switch (color) {
    case "orange":
      radioClassName = classes.orangeRadio;
      break;
    case "red":
      radioClassName = classes.redRadio;
      break;
    case "blue":
      radioClassName = classes.blueRadio;
      break;
    default:
      radioClassName = classes.orangeRadio;
  }
  return (
    <>
      <FormControl>
        <FormControlLabel
          label={label}
          {...props}
          {...field}
          control={<Radio className={radioClassName} />}
        />
      </FormControl>
    </>
  );
};

CustomRadio.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  props: PropTypes.any
};
export default CustomRadio;
